import { useAppDispatch, useAppSelector } from '@/redux/global-hooks';
import {
  logOutAction,
  selectUser,
  signInAction,
  updateUserAction,
} from '@/redux/slices/user.slice';

export default function useUser() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);

  const signInUser = (userData) => dispatch(signInAction(userData));
  const updateUser = (updateData) => dispatch(updateUserAction(updateData));
  const logOut = () => dispatch(logOutAction());

  return {
    user,
    signInUser,
    updateUser,
    logOut,
  };
}
